import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'flatBuilds';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const TOGGLE_BUILD_CARD = `${NAMESPACE}/TOGGLE_BUILD_CARD`;
export const CHANGE_TAB = `${NAMESPACE}/CHANGE_TAB`;
export const LOAD_INITIAL_DATA = createApiConstants(NAMESPACE, 'LOAD_INITIAL_DATA');
